import { useTranslation } from 'react-i18next';

import { Layout, OrganizationUsers } from '../../../components/app';
import { Button } from '../../../components/common';
import { ModalName } from '../../../enums';
import { useOpenModal } from '../../../features/modals';
import { useFetchOrganizationUsers } from '../../../features/organization';

export const OrganizationUsersPage = () => {
  const { t } = useTranslation();
  const openCreateUserModal = useOpenModal(ModalName.CREATE_USER);

  useFetchOrganizationUsers();

  return (
    <Layout
      backButton={{ title: t('organization.title.organization'), path: '/app/organization' }}
      rightButtons={[
        <Button
          key="add"
          text={t('organization.users.button.createUser')}
          size="sm"
          onClick={() => openCreateUserModal()}
        />,
      ]}
    >
      <OrganizationUsers expanded={true} />
    </Layout>
  );
};
